import type { CustomFieldValueDto } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/custom-field.js';
import type { CartHelpers } from './types';

export function useCartHelpers(): CartHelpers {
  const getCartProductVariantAttributeValueByExternalId = (
    cartLine: CartLine,
    externalId: string
  ): any => cartLine.productVariant && externalId;
  //cartLine.productVariant?.variantAttributesValues?.find((attr) => attr.id === externalId)?.value;

  const getCartOfferCustomFieldValueByExternalId = (
    cartLine: CartLine,
    externalId: string
  ): string | null => {
    return (
      cartLine.offer.customFieldValues.find((cf: CustomFieldValueDto) => cf.id === externalId)
        ?.value ?? null
    );
  };

  return {
    getCartProductVariantAttributeValueByExternalId,
    getCartOfferCustomFieldValueByExternalId,
  };
}
